<div
    class="modal fade generator-modal"
    id="appModal"
    #appModal
    tabindex="-1"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <button class="close" data-dismiss="modal"></button>
                    </div>

                    @if (!result) {
                        <div>
                            <app-camp-care-day-edit
                                [form]="form"
                            ></app-camp-care-day-edit>
                            <div class="row mt-1">
                                <div class="col-md-12">
                                    <button
                                        class="btn btn-success btn-modal right hoffset-5"
                                        bcClick
                                        (clicked)="generate()"
                                    >
                                        Generate
                                    </button>
                                    <button
                                        class="btn btn-danger btn-modal right"
                                        type="button"
                                        (click)="closeModal()"
                                    >
                                        {{ "General.Cancel" | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                    @if (result) {
                        <div>
                            <app-camp-care-days-generator-summary
                                [summary]="result"
                            ></app-camp-care-days-generator-summary>
                            <div class="row mt-1">
                                <div class="col-md-12">
                                    <button
                                        class="btn btn-success btn-modal right hoffset-5"
                                        (click)="closeModal()"
                                    >
                                        {{ "General.Ok" | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
